import Stores from "./Stores";
import Components from "./Components";
import UnitBinding from "./UnitBinding";
import CharacterReplacer from "./CharacterReplacer";

export default {
  Components,
  Stores,
  UnitBinding,
  CharacterReplacer
};



// WEBPACK FOOTER //
// ./src/Core/index.js